<h2 mat-dialog-title style="font-weight: 800; font-size: clamp(18px, 2vw, 24px);" class="text-center">{{config.title}}</h2>

<mat-dialog-content class="mt-2" style="max-height: 50vh !important;">
    <div [innerHTML]="config.html" style="font-size: clamp(14px, 2vw, 16px);"></div>
</mat-dialog-content>

<div mat-dialog-actions class="d-flex justify-content-center">
    <button mat-flat-button color="primary" class="mt-2 mt-md-4" style="width: 100px;"
        (click)="confirm()">{{config.button}}</button>
</div>